export const Actions = {
    BANKS_FETCH_INIT: 'BANKS_FETCH_INIT',
    BANKS_FETCH_SUCCESS: 'BANKS_FETCH_SUCCESS',
    BANKS_FETCH_ERROR: 'BANKS_FETCH_ERROR',
    BANKS_FETCH_RESET: 'BANKS_FETCH_RESET',
    BANKS_SELECT_ACCOUNT: 'BANKS_SELECT_ACCOUNT',
    BANKS_SHOW_NEW_ACCOUNT_ACCOUNT: 'BANKS_SHOW_NEW_ACCOUNT_ACCOUNT',
};
